import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FileSpreadsheet } from 'lucide-react';
import {
  Badge,
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle
} from '@bliks-io/ui';
import { BetaBadge } from '@/components/beta-badge/BetaBadge';

interface SourceRowProps {
  description?: ReactNode;
  actions: ReactNode;
}

/** The Excel row of the Datenabgleich settings page and the wizard's source choice. */
export function ExcelSourceRow({ description, actions }: SourceRowProps) {
  const { t } = useTranslation();

  return (
    <Item variant="outline">
      <ItemMedia variant="icon">
        <FileSpreadsheet className="text-bliks-green-800" />
      </ItemMedia>
      <ItemContent>
        <ItemTitle>{t('dataSync.settings.kind.excel')}</ItemTitle>
        {description && <ItemDescription>{description}</ItemDescription>}
      </ItemContent>
      <ItemActions className="flex-wrap">{actions}</ItemActions>
    </Item>
  );
}

/** The Personio row of the Datenabgleich settings page and the wizard's source choice. */
export function PersonioSourceRow({
  connected,
  description,
  actions
}: SourceRowProps & { connected: boolean }) {
  const { t } = useTranslation();

  return (
    <Item variant="outline">
      <ItemMedia>
        <img
          src="/assets/images/personio-logo.svg"
          alt={t('dataSync.settings.kind.personio')}
          className="h-8 w-auto"
        />
      </ItemMedia>
      <ItemContent>
        <ItemTitle>
          {connected && <Badge colorScheme="success">{t('dataSync.settings.connected')}</Badge>}
          <BetaBadge />
        </ItemTitle>
        {description && <ItemDescription>{description}</ItemDescription>}
      </ItemContent>
      <ItemActions className="flex-wrap">{actions}</ItemActions>
    </Item>
  );
}
